import React from 'react';
import { MDBDataTable } from 'mdbreact';
import dayjs from 'dayjs';
import { Badge, Button } from 'reactstrap';

const columns = [
  {
    label: 'Buyer',
    field: 'buyer',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Phone',
    field: 'phone',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Bid Price',
    field: 'amount',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Qty',
    field: 'qty',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Created At',
    field: 'createdAt',
    sort: 'asc',
    width: 270,
  },
];
const MundiBidsList = (props) => {
  return (
    <>
      <MDBDataTable
        btn
        responsive
        bordered
        data={{
          columns: columns,
          rows: props?.bids?.map((x) => ({
            buyer: x?.buyer?.name,
            phone: x?.buyer?.phone,
            amount: 'Rs ' + x?.amount,
            qty: x?.amount + ' ' + props?.ad?.weightUnit,
            createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
          })),
        }}
      />
    </>
  );
};

export default MundiBidsList;
